<template>
  <div class="autocomplete">
    <input v-model="searchTerm" @input="handleInput" class="uk-input" />
    <div v-if="showDropdown" class="dropdown">
      <div
        v-for="(item, index) in searchResults"
        :key="index"
        @click="selectItem(item)"
        class="dropdown-item bg-white cursor-pointer p-2 hover:bg-gray-200"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>
<script>
import http from "../../services/http";
export default {
  data() {
    return {
      searchTerm: "",
      searchResults: [],
      showDropdown: false
    };
  },
  props: ["table", "field"],

  watch: {
    searchTerm() {
      this.$emit("okeyto", this.searchTerm);
    }
  },
  methods: {
    handleInput() {
      if (this.searchTerm.length >= 2) {
        const searchTermCopy = this.searchTerm;
        http
          .getAutoCompleteKeys(this.table, this.field, searchTermCopy)
          .then(response => {
            this.searchResults = response.data;
            this.showDropdown = true;
          })
          .catch(error => {
            console.error("Error fetching data:", error);
          });
      } else {
        this.searchResults = [];
        this.showDropdown = false;
      }
    },
    selectItem(item) {
      this.searchTerm = item;
      this.showDropdown = false;
      this.$parent.$emit("okeyto", {
        name: this.field,
        value: this.searchTerm
      });
    }
  }
};
</script>
<style scoped>
.dropdown {
  position: absolute;
  max-height: 200px;
  min-width: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  z-index: 1000;
}

.dropdown-item {
  transition: background-color 0.3s;
}
</style>
